import React from 'react';

/**
 * EmptyState - friendly placeholder when a list/table has no data.
 *
 * Props:
 *   icon     - emoji or React node
 *   title    - bold one-liner
 *   subtitle - secondary descriptive text
 *   action   - optional React node (typically a button)
 */
export default function EmptyState({ icon = '📭', title, subtitle, action, className = '' }) {
  return (
    <div className={`flex flex-col items-center justify-center text-center py-14 px-6 ${className}`}>
      <div className="relative w-16 h-16 mb-5">
        <div className="absolute inset-0 rounded-full bg-gradient-brand opacity-15 blur-xl" aria-hidden="true" />
        <div className="relative w-16 h-16 rounded-2xl bg-white border border-slate-200 shadow-soft flex items-center justify-center text-2xl">
          {icon}
        </div>
      </div>
      {title && <h3 className="text-base font-semibold text-slate-900 tracking-tight">{title}</h3>}
      {subtitle && <p className="mt-1.5 text-sm text-slate-500 max-w-sm">{subtitle}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
